import { useEffect, useState } from "react";
import Header from "../../../components/Assessment/Header/Header";
import "./JobShare.scss";
import {
  companyGetJobDetails,
  getSourcesList,
  jobsGetOtp,
  jobsResendOtp,
  jobsVerifyOtp,
} from "../../../service/CvScanning/CvScanning";
import { useParams } from "react-router-dom";
import BackArrow from "../../../utils/Images/BackArrow";
import {
  capitalizeFirstLetter,
  copyToClipboard,
  emailRegex,
  formatTime,
} from "../../../utils/Common/Constant";
import { useTranslation } from "react-i18next";
import {
  AssessmentButton,
  CheckboxRadio,
  InputField,
  showToast,
  TypeSelect,
} from "ui-components";
import SocialMediaJobShare from "./SocialMediaJobShare";
import Footer from "../../../components/Footer/Footer";
import CopyVector from "../../../utils/Images/CopyVector";
import Loader from "../../../components/Loader/Loader";
import { JobScreensEnums } from "../../../utils/Enums/JobScreensEnums";

const JobShare = () => {
  const [jobShareDetails, setJobShareDetails] = useState<any>(null);
  const [shareJobDetailsLoading, setShareJobDetailsLoading] = useState(false);
  const companyEmail = localStorage.getItem("email") || "";
  const [emailText, setEmailText] = useState(
    localStorage.getItem("jobShareAddedEmail") ?? "",
  );
  const [addedEmail, setAddedEmail] = useState(
    localStorage.getItem("jobShareAddedEmail") ?? "",
  );
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [hashtags, setHashtags] = useState<any>([]);
  const [otpText, setOtpText] = useState("");
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [getOtpLoading, setGetOtpLoading] = useState(false);
  const [verifyOtpLoading, setVerifyOtpLoading] = useState(false);
  const [isCurrentMailVerified, setIsCurrentMailVerified] = useState(
    localStorage.getItem("CurrentMainVerified") == "true" || false,
  );
  const [timer, setTimer] = useState(60);
  const [isTimerActive, setIsTimerActive] = useState(false);
  const [resendBtnDisable, setResendBtnDisable] = useState(false);
  const [allEmails, setAllEmails] = useState<any>([]);
  const [selectedEmail, setSelectedEmail] = useState(
    localStorage.getItem("jobShareSelectedEmail") ?? "",
  );
  useEffect(() => {
    const savedTime = sessionStorage.getItem("leftTime");
    if (savedTime !== null) {
      const timeRemaining = Number(savedTime);
      if (timeRemaining > 0) {
        setTimer(timeRemaining);
        setIsTimerActive(true);
      } else {
        setTimer(0);
        setIsTimerActive(false);
      }
    } else {
      sessionStorage.setItem("leftTime", "60");
    }

    const interval = setInterval(() => {
      setTimer((prevTime) => {
        if (prevTime > 1) {
          sessionStorage.setItem("leftTime", (prevTime - 1).toString());
          return prevTime - 1;
        } else {
          clearInterval(interval);
          setIsTimerActive(false);
          sessionStorage.setItem("leftTime", "0");
          setResendBtnDisable(false);
          return 0;
        }
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [isTimerActive]);
  const { t } = useTranslation();
  const [applyOption, setApplyOption] = useState<string>(
    t("RESUME.CV_VIA_JOBLINK"),
  );
  const { jobId } = useParams();
  useEffect(() => {
    if (jobId) {
      setShareJobDetailsLoading(true);
      const getJobDetails = async () => {
        const jobDetailsRes = await companyGetJobDetails(jobId);
        if (jobDetailsRes?.status === 200) {
          setJobShareDetails(jobDetailsRes?.data);
        }
        setShareJobDetailsLoading(false);
      };
      getJobDetails();
    }
  }, []);

  const validateEmail = (email: string) => {
    return emailRegex.test(email);
  };

  const handleEmailChange = (e: any) => {
    setEmailText(e.trim());
    setIsEmailValid(validateEmail(e.trim()));
  };
  const [inputValue, setInputValue] = useState("");

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter" && inputValue.trim() !== "") {
      event.preventDefault();
      const formattedInput = inputValue.startsWith("#")
        ? inputValue
        : `#${inputValue}`;

      setHashtags([...hashtags, formattedInput.trim()]);
      setInputValue("");
    }
  };

  const handleJdCopy = () => {
    const previewBox: any = document.querySelector(".previewBox");
    if (previewBox) {
      const textToCopy = previewBox.innerText; // Extracts only the visible text
      copyToClipboard(
        { current: true },
        textToCopy,
        t("GENERAL.JOB_DESCRIPTION_COPIED"),
      );
    }
  };
  //  get otp on email
  const getOtpOnMail = async (email: any) => {
    const data = {
      email,
      type: "Company",
    };
    setGetOtpLoading(true);
    try {
      const getCompanyOtp = await jobsGetOtp(data);
      if (getCompanyOtp?.status === 200) {
        showToast(getCompanyOtp?.customMessage, "success");
        setIsOtpSent(true);
        setIsTimerActive(true);
        setTimer(60);
        sessionStorage.setItem("leftTime", "60");
        setResendBtnDisable(true);
      } else {
        showToast(getCompanyOtp?.customMessage, "error");
        setIsOtpSent(true);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      setGetOtpLoading(false);
    }
  };
  // verify otp
  const verifyOtp = async () => {
    setVerifyOtpLoading(true);
    const data = {
      email: emailText,
      type: "Company",
      otp: Number(otpText),
    };
    try {
      const res = await jobsVerifyOtp(data);
      if (res?.status === 200) {
        showToast(res?.customMessage, "success");
        setAddedEmail(emailText);
        setIsOtpSent(false);
        setIsCurrentMailVerified(true);
        setOtpText("");
        localStorage.setItem("jobShareAddedEmail", emailText);
        localStorage.setItem("CurrentMainVerified", "true");
      }
    } catch (error) {
      console.error(error);
    } finally {
      setVerifyOtpLoading(false);
    }
  };
  // resend otp api
  const resendOtpApi = async () => {
    setTimer(60);
    sessionStorage.setItem("leftTime", "60");
    setResendBtnDisable(true);
    const data = {
      email: emailText,
      type: "Company",
    };
    try {
      const res = await jobsResendOtp(data);
      showToast(res.customMessage, "success");
      setIsTimerActive(true);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    getSourcesListApi();
  }, []);
  const getSourcesListApi = async () => {
    try {
      const res = await getSourcesList(jobId);
      const sourceList = res?.data?.data || [];
      const sortedSourceList = Array.from(
        new Set([
          companyEmail,
          ...sourceList
            .filter((item: any) => item.type !== JobScreensEnums.TYPE_DATABASE)
            .map((item: any) => item.identifier),
          "Other",
        ]),
      );
      const emailObjects = sortedSourceList.map((email) => ({
        label: email,
        value: email,
      }));
      setAllEmails(emailObjects);
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <>
      <Header />
      {shareJobDetailsLoading ? (
        <div className="minHeight100 d-flex align-items-center justify-content-center jobLoader">
          <Loader />
        </div>
      ) : (
        <div className="container-fluid jobShareSection minHeight100">
          <div className="arrowTitle">
            <div className="backArrow" onClick={() => window.history.back()}>
              <BackArrow />
            </div>
            <span>
              {jobShareDetails?.title
                ? capitalizeFirstLetter(jobShareDetails?.title)
                : "-"}
            </span>
          </div>
          <div className="jobShareContainer row">
            <div className="jobDescription col-md-6">
              <h3 className="jobDes">{t("RESUME.SCANNING_JOB_DESCRIPTION")}</h3>
              <p className="jobLink">
                <span className="jobLinkTitle">
                  {t("RESUME.SCANNING_PUBLIC_LINK")}
                </span>
                <a
                  className="jonLikUrl"
                  target="_blank"
                  rel="noreferrer"
                  href={jobShareDetails?.applyLink}
                >
                  {jobShareDetails?.applyLink}
                </a>
              </p>
              <div className="descriptionBox">
                <p
                  dangerouslySetInnerHTML={{
                    __html: jobShareDetails?.description || "-",
                  }}
                />
              </div>
              <div className="hashtagSection">
                <div className="hashtagInput">
                  <span>{t("RESUME.HASHTAG")}</span>
                  <div className="inputHashtag">
                    <InputField
                      type="text"
                      placeholder="#java"
                      value={inputValue}
                      onChange={(e: any) => setInputValue(e)}
                      additionalProps={{
                        onKeyDown: handleKeyDown,
                      }}
                    />
                    <div className="hashtags">
                      {hashtags?.map((item: any, index: any) => (
                        <span key={index}>{item}</span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              <div className="toggleDescription applyOptions">
                <CheckboxRadio
                  name="applyOptions"
                  type="radio"
                  checked={applyOption === t("RESUME.CV_VIA_JOBLINK")}
                  onChange={() => {
                    setApplyOption(t("RESUME.CV_VIA_JOBLINK"));
                  }}
                  label={t("RESUME.CV_VIA_JOBLINK")}
                />
                <CheckboxRadio
                  name="applyOptions"
                  type="radio"
                  checked={applyOption === t("RESUME.CV_VIA_EMAIL")}
                  onChange={() => {
                    setApplyOption(t("RESUME.CV_VIA_EMAIL"));
                  }}
                  label={t("RESUME.CV_VIA_EMAIL")}
                />
                {applyOption === t("RESUME.CV_VIA_EMAIL") && (
                  <>
                    <div className="shortLine mt-2 mb-3">
                      <hr />
                    </div>
                    <div className="emailSelection">
                      <TypeSelect
                        options={allEmails}
                        loadingText=""
                        value={selectedEmail}
                        onChange={(e: string) => {
                          setSelectedEmail(e);
                          localStorage.setItem("jobShareSelectedEmail", e);
                          if (e !== "Other") {
                            setAddedEmail(e);
                            localStorage.setItem("jobShareAddedEmail", e);
                          }
                        }}
                        placeholder={t("GENERAL.SELECT_EMAIL")}
                      />
                    </div>
                    {selectedEmail === "Other" &&
                      (!isOtpSent ? (
                        <div className="emailField">
                          <InputField
                            onChange={handleEmailChange}
                            value={emailText?.trim()}
                            placeholder={t("GENERAL.EMAIL")}
                            additionalProps={{
                              disabled: isCurrentMailVerified,
                            }}
                          />
                          {allEmails?.some(
                            (email: any) =>
                              email.label.toLowerCase() ==
                              emailText.toLowerCase(),
                          ) || isCurrentMailVerified ? (
                            <div className="addEmailBtn">
                              <AssessmentButton
                                onClick={() => {
                                  if (isCurrentMailVerified) {
                                    setIsCurrentMailVerified(false);
                                  } else if (isEmailValid) {
                                    setAddedEmail(emailText);
                                    setIsCurrentMailVerified(true);
                                    localStorage.setItem(
                                      "jobShareAddedEmail",
                                      emailText,
                                    );
                                    localStorage.setItem(
                                      "CurrentMainVerified",
                                      "true",
                                    );
                                  }
                                }}
                                disabled={!isEmailValid}
                              >
                                {isCurrentMailVerified
                                  ? t("GENERAL.EDIT")
                                  : t("GENERAL.ADD")}
                              </AssessmentButton>
                            </div>
                          ) : (
                            <div className="getOtpBtn">
                              <AssessmentButton
                                onClick={() => {
                                  if (isEmailValid) getOtpOnMail(emailText);
                                }}
                                disabled={getOtpLoading || !isEmailValid}
                              >
                                {getOtpLoading ? (
                                  <div className="pleaseWaitLoader">
                                    {t("GENERAL.PLEASE_WAIT")}
                                    <Loader />
                                  </div>
                                ) : (
                                  t("GENERAL.GET_OTP")
                                )}
                              </AssessmentButton>
                            </div>
                          )}
                        </div>
                      ) : (
                        <div className="emailText d-flex justify-content-between">
                          <span>{emailText}</span>
                          <div className="resend-otp-sec">
                            {!isTimerActive ? (
                              <div
                                className={`resend-otp-btn ${resendBtnDisable ? "disable-resend-btn" : ""}`}
                                onClick={
                                  !isTimerActive ? resendOtpApi : () => {}
                                }
                              >
                                <span>{t("GENERAL.RESEND_OTP")}</span>
                              </div>
                            ) : (
                              <span>
                                &nbsp;
                                {formatTime(Number(timer))}
                              </span>
                            )}
                          </div>
                        </div>
                      ))}
                    {!isEmailValid && emailText && (
                      <span className="errorMessage">
                        {t("ERROR.INVALID_EMAIL_ADDRESS")}
                      </span>
                    )}

                    {selectedEmail === "Other" && isOtpSent && (
                      <div className="emailField">
                        <InputField
                          onChange={(e: any) => setOtpText(e)}
                          value={otpText}
                          placeholder={`${t("GENERAL.ENTER_OTP")} ${emailText}`}
                        />
                        <div className="getOtpBtn">
                          <AssessmentButton
                            onClick={() => verifyOtp()}
                            disabled={verifyOtpLoading || !otpText}
                          >
                            {verifyOtpLoading ? (
                              <div className="pleaseWaitLoader">
                                {t("GENERAL.PLEASE_WAIT")}
                                <Loader />
                              </div>
                            ) : (
                              t("GENERAL.VERIFY_OTP")
                            )}
                          </AssessmentButton>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>

            <div className="previewSection col-md-6">
              <div className="d-flex gap-2">
                <h4 className="preview">{t("RESUME.PREVIEW")}</h4>
                <div
                  className="cursorPointer"
                  title="Copy Job Description"
                  onClick={handleJdCopy}
                >
                  <CopyVector />
                </div>
              </div>
              <div className="shortLine">
                <hr />
              </div>
              <div className="previewBox">
                <div className="mt-3 descriptionText">
                  <p
                    dangerouslySetInnerHTML={{
                      __html: `${jobShareDetails?.description || "-"}`,
                    }}
                  />
                </div>
                <div className="mt-3">
                  {addedEmail && applyOption == t("RESUME.CV_VIA_EMAIL") ? (
                    <div className="linkSection">
                      <span>{t("RESUME.SEND_CV_TO_EMAIL")}</span>
                      <a className="applyLink">{addedEmail}</a>
                    </div>
                  ) : (
                    <div className="linkSection">
                      <span>{t("RESUME.VISIT_LINK_TO_JOB_APPLY")}</span>
                      <a
                        className="applyLink"
                        href={jobShareDetails?.applyLink}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {jobShareDetails?.applyLink}
                      </a>
                    </div>
                  )}
                </div>
                <div className="previewHashtags">
                  {hashtags?.map((item: any, index: any) => (
                    <span key={index}>{item}</span>
                  ))}
                </div>
              </div>
              <div className="shareButton">
                <div className="shareOn">
                  <span>{t("RESUME.SHARE_ON")}: </span>
                </div>
                <div className="shareContainer show">
                  <SocialMediaJobShare
                    description={jobShareDetails?.description || ""}
                    hashtags={hashtags.join(" ")}
                    shareUrl={
                      addedEmail && applyOption == t("RESUME.CV_VIA_EMAIL")
                        ? addedEmail
                        : jobShareDetails?.applyLink
                    }
                    title={
                      jobShareDetails?.title
                        ? capitalizeFirstLetter(jobShareDetails?.title)
                        : ""
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <Footer />
    </>
  );
};

export default JobShare;
